import React from 'react'
import Anexos from './Anexos'
import { Icon } from './../../../components/Layout'

const Condicionante = React.memo(({ cond }) => {

    const statusMap = {
        'vencida': 'status-vencida',
        'vencendomes': 'status-vencendo',
        'default': 'status-aberta'
    }

    const cardStatusClass = statusMap[cond.circleStatus] || statusMap['default']
    const iconClass = cond.circleStatus === 'vencida' ? 'ti-alert text-danger' :
        cond.circleStatus === 'vencendomes' ? 'ti-time text-warning' : 'ti-file text-info'

    return (
        <div className={`card cond-card ${cardStatusClass}`}>
            <div className="card-body">

                <div className="cond-header">
                    <div className="cond-title-group">
                        <div className="cond-icon-wrapper">
                            <i className={`cond-icon ${iconClass}`}></i>
                        </div>
                        <div className="cond-main-info">
                            <h4 className="cond-title">{cond.descricao}</h4>
                            <div className="cond-subtitles">
                                {cond.cliente && (
                                    <div className="cond-subtitle-row row-client">
                                        <Icon name="ti-user" />
                                        <span>{cond.cliente}</span>
                                    </div>
                                )}
                                {cond.clienteemail && (
                                    <div className="cond-subtitle-row">
                                        <Icon name="ti-email" />
                                        <span>{cond.clienteemail}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Badges & Meta Info */}
                <div className="cond-meta-grid">
                    <div className="cond-badges-row">
                        {cond.item && <span className="badge bg-soft-secondary">Item: {cond.item}</span>}
                        {cond.anexo && <span className="badge bg-soft-secondary">Anexo: {cond.anexo}</span>}
                    </div>

                    {cond.observacao &&
                        <div className="cond-observation">
                            <i className="ti-info-alt"></i>
                            <span>{cond.observacao}</span>
                        </div>
                    }
                </div>

                {cond.listaAnexos && cond.listaAnexos.length > 0 &&
                    <div className="cond-anexos-wrapper">
                        <Anexos anexos={cond.listaAnexos} />
                    </div>
                }

                <div className="cond-footer">
                    <div className="user-info">
                        <img src={cond.avatar} alt={cond.usuario} />
                        <div className="user-details">
                            <span className="name">{cond.usuario}</span>
                            <span className="role">{cond.nivel}</span>
                        </div>
                    </div>

                    <div className="date-info">
                        <div className="date-block">
                            <span className="date-label">Prazo</span>
                            <span className={`date-val ${cond.circleStatus === 'vencida' ? 'text-danger' : ''}`}>
                                {cond.data_prazo}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
})

export default Condicionante